<div *ngIf="showModal">
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <img class="modal-icon" style="width: 20px;" src="assets/ico/fill.svg" alt="icon">
                    <span class="modal-title" id="modal-basic-title">{{ 'order.budget.filler.title' | translate }}
                    </span>
                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close(null)" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <p class="text-center" style="margin-top: -35px; padding: 50px; padding-bottom: 0px;"><strong>Add additional hours to
                the budget by using a
                preset or
                entering custom quantities</strong>
            <br />
            (percentage values are relative to available hours)
        </p>
        <div class="progress-bar-wrapper">
            <progress-bar [progress]="totalProgress" [color]="'#488aff'"> </progress-bar>
            <div class="position-relative" style="height: 40px;">
                <button (click)="calcTotalProgress(0)" (mouseover)="setTempValues(0)" (mouseout)="returnOldValues()"
                    class="position-absolute perc-button" style="left: -3%;">Reset</button>
                <button (click)="calcTotalProgress(0.25)" (mouseover)="setTempValues(0.25)"
                    (mouseout)="returnOldValues()" class="position-absolute perc-button"
                    style="left: 22.5%;">25%</button>
                <button (click)="calcTotalProgress(0.33)" (mouseover)="setTempValues(0.33)"
                    (mouseout)="returnOldValues()" class="position-absolute perc-button"
                    style="left: 29.3%;">33,3%</button>
                <button (click)="calcTotalProgress(0.50)" (mouseover)="setTempValues(0.5)"
                    (mouseout)="returnOldValues()" class="position-absolute perc-button"
                    style="left: 47.5%;">50%</button>
                <button (click)="calcTotalProgress(0.666)" (mouseover)="setTempValues(0.666)"
                    (mouseout)="returnOldValues()" class="position-absolute perc-button"
                    style="left: 62.6%;">66,6%</button>
                <button (click)="calcTotalProgress(0.75)" (mouseover)="setTempValues(0.75)"
                    (mouseout)="returnOldValues()" class="position-absolute perc-button" style="left: 72%;">75%</button>
                <button (click)="calcTotalProgress(1)" (mouseover)="setTempValues(1)" (mouseout)="returnOldValues()"
                    class="position-absolute perc-button" style="left: 96.5%;">100%</button>
            </div>
        </div>
        <table *ngIf="forms.controls.length > 0">
            <caption style="display: none;">Budget filler table</caption>
            <tr>
                <th style="text-align: left;" scope="col">Name</th>
                <th style="text-align: left;" scope="col">Code</th>
                <th scope="col">Existing hours</th>
                <th style="max-width: 30px; width: 30px;" scope="col"></th>
                <th scope="col">Selected hours</th>
                <th style="max-width: 30px; width: 30px;" scope="col"></th>
                <th scope="col">Resulting hours</th>
            </tr>
            <tr class="available-products" *ngFor="let product of forms.controls">
                <td>{{product.controls.name.value}}</td>
                <td style="text-align: left;">{{product.controls.code.value}}</td>
                <td>{{product.controls.startingHours.value.toFixed(2).replace(".", ",")}}</td>
                <td style="max-width: 30px; width: 30px; position: relative;">
                    <div style="position: absolute; top: 24px;">+</div>
                </td>
                <td style="position: relative;">
                    <form [formGroup]="product" class="editForm">
                        <apc-form-input [class]="product.controls.progressClasses.value" [class.hovering]="mouseIn"
                            formControlName="quantity" [type]="'number'"
                            [disabled]="product.controls.available.value === 0"
                            (isChanged)="progressColorCalc(product)">
                        </apc-form-input>
                    </form>
                    <div class="available-quantity"> of {{product.controls.available.value.toFixed(2).replace(".",
                        ",")}}</div>
                    <div style="margin-top: 15px;">
                        <progress-bar [progress]="calcProgress(product)" [disable-percentage]="true"
                            class="progress-form"
                            [class.progressBgColorGrey]="product.controls.backgroundProgressColor.value === 'grey'"
                            [class.progressBgColorGreen]="product.controls.backgroundProgressColor.value === 'green'"
                            [color]="product.controls.progressColor.value" [id]="product.controls.identifier.value">
                        </progress-bar>
                    </div>
                </td>
                <td style="max-width: 30px; width: 30px; position: relative;">
                    <div style="position: absolute; top: 24px; left: 15px;">=</div>
                </td>
                <td>{{(parseNum(product.controls.startingHours.value) +
                    parseNum(product.controls.quantity.value)).toFixed(2).replace(".", ",")}}</td>
            </tr>

            <tr class="not-available-products" *ngFor="let product of notAvailableForms.controls">
                <td>{{product.controls.name.value}}</td>
                <td style="text-align: left;">{{product.controls.code.value}}</td>
                <td>{{product.controls.startingHours.value.toFixed(2).replace(".", ",")}}</td>
                <td style="max-width: 30px; width: 30px; position: relative;">
                    <div style="position: absolute; top: 24px;">+</div>
                </td>
                <td style="position: relative;">
                    <form [formGroup]="product" class="editForm">
                        <apc-form-input [class]="product.controls.progressClasses.value" [class.hovering]="mouseIn"
                            formControlName="quantity" [type]="'number'"
                            [disabled]="product.controls.available.value === 0"
                            (isChanged)="progressColorCalc(product)">
                        </apc-form-input>
                    </form>
                    <div class="available-quantity"> of {{product.controls.available.value.toFixed(2).replace(".",
                        ",")}}</div>
                    <div style="margin-top: 15px;">
                        <progress-bar [progress]="calcProgress(product)" [disable-percentage]="true"
                            class="progress-form"
                            [class.progressBgColorGrey]="product.controls.backgroundProgressColor.value === 'grey'"
                            [class.progressBgColorGreen]="product.controls.backgroundProgressColor.value === 'green'"
                            [color]="product.controls.progressColor.value" [id]="product.controls.identifier.value">
                        </progress-bar>
                    </div>
                </td>
                <td style="max-width: 30px; width: 30px; position: relative;">
                    <div style="position: absolute; top: 24px; left: 15px;">=</div>
                </td>
                <td>{{(parseNum(product.controls.startingHours.value) +
                    parseNum(product.controls.quantity.value)).toFixed(2).replace(".", ",")}}</td>
            </tr>
        </table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn modal-btn" [class.disabledButton]="saveDisabled" [disabled]="saveDisabled"
            (click)="save()">Save</button>
    </div>
</div>